import FAQItems from "../components/FAQItems";

const TEXT = "#EDEDED";
const TEXT_DIM = "#a0a0a0";
const TEAL = "#4FCDC4";
const TEAL_DIM = "rgba(79,205,196,0.15)";
const TEAL_BORDER = "rgba(79,205,196,0.35)";
const CARD_BORDER = "rgba(255,255,255,0.04)";
const TABLE_BORDER = "rgba(255,255,255,0.08)";
const AMBER = "#E0A458";

const CLOUDFLARE_PRESS = "https://www.cloudflare.com/press/press-releases/2026/cloudflare-allows-the-agentic-internet-to-flourish-with-a-simple-philosophy-your-content-your-rules/";
const CLOUDFLARE_AI_BOTS_DOC = "https://developers.cloudflare.com/bots/additional-configurations/block-ai-bots/";
const CLOUDFLARE_BFM_DOC = "https://developers.cloudflare.com/bots/get-started/bot-fight-mode/";
const RFC_9309 = "https://www.rfc-editor.org/rfc/rfc9309.html";

function H2({ id, children }) {
  return <h2 id={id} style={{ fontFamily: "var(--display)", fontWeight: 700, fontSize: "clamp(22px, 3vw, 28px)", color: TEXT, margin: "48px 0 16px", letterSpacing: "-0.01em", lineHeight: 1.2 }}>{children}</h2>;
}
function P({ children }) {
  return <p style={{ fontFamily: "var(--body)", fontSize: 16, color: TEXT_DIM, lineHeight: 1.85, margin: "0 0 18px" }}>{children}</p>;
}
function Li({ children }) {
  return <li style={{ fontFamily: "var(--body)", fontSize: 16, color: TEXT_DIM, lineHeight: 1.8, marginBottom: 8 }}>{children}</li>;
}
function Strong({ children }) {
  return <strong style={{ color: TEXT, fontWeight: 700 }}>{children}</strong>;
}
function Code({ children }) {
  return <code style={{ fontFamily: "var(--mono)", fontSize: 14, color: TEXT, background: "rgba(255,255,255,0.06)", padding: "2px 6px", borderRadius: 4 }}>{children}</code>;
}
function A({ href, children }) {
  const isExternal = href.startsWith("http");
  return <a href={href} {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})} style={{ color: TEAL, textDecoration: "underline", fontWeight: 600 }}>{children}</a>;
}
function PullQuote({ children }) {
  return (
    <blockquote style={{ margin: "32px 0", padding: "20px 24px", borderLeft: `3px solid ${TEAL}`, fontFamily: "var(--display)", fontSize: 20, fontWeight: 600, color: TEXT, lineHeight: 1.4, fontStyle: "normal" }}>
      {children}
    </blockquote>
  );
}
function InlineCTA({ children, href, label }) {
  return (
    <div style={{ margin: "40px 0", padding: "24px 28px", borderRadius: 14, background: TEAL_DIM, border: "1px solid rgba(78,205,196,0.25)" }}>
      <p style={{ fontFamily: "var(--body)", fontSize: 15, color: TEXT, margin: "0 0 12px", fontWeight: 600 }}>{children}</p>
      <a href={href} style={{ color: TEAL, fontFamily: "var(--body)", fontSize: 15, fontWeight: 700, textDecoration: "none" }}>
        {label} &#8594;
      </a>
    </div>
  );
}

const thStyle = { textAlign: "left", fontSize: 11, fontWeight: 700, color: TEXT_DIM, textTransform: "uppercase", letterSpacing: "0.06em", padding: "10px 12px", borderBottom: "1px solid rgba(255,255,255,0.12)", whiteSpace: "nowrap" };
const tdStyle = { fontSize: 14, color: TEXT_DIM, padding: "12px", borderBottom: `1px solid ${CARD_BORDER}`, lineHeight: 1.55, verticalAlign: "top" };

function TableCard({ title, note, minWidth, children }) {
  return (
    <div style={{ background: "#0f0f11", borderRadius: 12, border: `1px solid ${CARD_BORDER}`, padding: 24, margin: "16px 0 32px", overflow: "hidden" }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: TEXT, marginBottom: 4, fontFamily: "var(--body)" }}>{title}</div>
      <div style={{ fontSize: 11, color: TEXT_DIM, marginBottom: 16, fontFamily: "var(--body)", lineHeight: 1.5 }}>{note}</div>
      <div className="blog-scroll-wrap" style={{ overflowX: "auto", WebkitOverflowScrolling: "touch", margin: "0 -4px" }}>
        <table style={{ width: "100%", minWidth, borderCollapse: "collapse", fontFamily: "var(--body)" }}>{children}</table>
      </div>
    </div>
  );
}

/* ── Visual 1: EditionStats ── the quarter in four numbers, same-site basis */
function EditionStats() {
  const stats = [
    { big: "76", label: "sites name AI crawlers in robots.txt", sub: "Up from 55 in June, across the 358 sites readable in both scans" },
    { big: "552", label: "rules that let an AI crawler in", sub: "Up from 349. Rules that block one rose from 44 to 55" },
    { big: "0", label: "sites newly blocked an AI search crawler", sub: "Seven sites added blocks. None of the new blocks hit AI search" },
    { big: "0.6%", label: "block an AI search crawler", sub: "2 of 362 readable sites on September 15, 2026" },
  ];
  return (
    <div style={{ margin: "28px 0 36px", border: `1px solid ${TABLE_BORDER}`, borderRadius: 14, overflow: "hidden" }}>
      <div style={{ padding: "16px 20px", background: "rgba(255,255,255,0.03)", borderBottom: `1px solid ${TABLE_BORDER}` }}>
        <div style={{ fontFamily: "var(--display)", fontSize: 13, fontWeight: 700, color: TEAL, letterSpacing: "0.08em", textTransform: "uppercase" }}>AI Bot Blocking Index, September 2026</div>
        <div style={{ fontFamily: "var(--body)", fontSize: 13, color: TEXT_DIM, marginTop: 4 }}>The same 390 B2B SaaS sites, scanned June 27 and September 15, 2026.</div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))" }}>
        {stats.map((s, i) => (
          <div key={s.label} style={{ padding: "22px 20px", borderRight: i < stats.length - 1 ? `1px solid ${TABLE_BORDER}` : "none", minWidth: 0 }}>
            <div style={{ fontFamily: "var(--display)", fontSize: 34, fontWeight: 700, color: i === 2 ? TEAL : TEXT, lineHeight: 1.1 }}>{s.big}</div>
            <div style={{ fontFamily: "var(--body)", fontSize: 14, color: TEXT, fontWeight: 600, marginTop: 8 }}>{s.label}</div>
            <div style={{ fontFamily: "var(--body)", fontSize: 12.5, color: TEXT_DIM, marginTop: 4, lineHeight: 1.45 }}>{s.sub}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── Visual 2: EditionCompare ── June vs September on the 358 sites readable both times */
function EditionCompare() {
  const rows = [
    ["Sites with any AI-crawler rule", "55", "76"],
    ["Rules that let an AI crawler in", "349", "552"],
    ["Rules that block an AI crawler", "44", "55"],
    ["Sites that let GPTBot in by name", "44", "62"],
    ["Sites that block GPTBot", "6", "7"],
    ["Sites that block Bytespider", "7", "11"],
    ["Sites that block an AI search crawler", "3", "2"],
  ];
  return (
    <TableCard
      title="What moved between June and September 2026"
      note="The 358 sites whose robots.txt was readable in both scans. A rule lets a crawler in when the file names it without blocking the whole site."
      minWidth={520}
    >
      <thead>
        <tr>
          {["Measure", "June 27", "September 15"].map((h, i) => (
            <th key={h} style={{ ...thStyle, textAlign: i === 0 ? "left" : "right" }}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map(([label, june, sept]) => (
          <tr key={label}>
            <td style={{ ...tdStyle, color: TEXT, fontWeight: 600 }}>{label}</td>
            <td style={{ ...tdStyle, textAlign: "right", fontFamily: "var(--mono)" }}>{june}</td>
            <td style={{ ...tdStyle, textAlign: "right", fontFamily: "var(--mono)", color: TEAL, fontWeight: 700 }}>{sept}</td>
          </tr>
        ))}
      </tbody>
    </TableCard>
  );
}

/* ── Visual 3: NewBlocksTable ── every site that added a block, and its search posture */
function NewBlocksTable() {
  const rows = [
    { site: "github.com", cohort: "Established", added: "Bytespider", search: "Names OAI-SearchBot and PerplexityBot with page-level rules, no site-wide block" },
    { site: "postman.com", cohort: "Established", added: "Bytespider", search: "Lets all five in" },
    { site: "amplitude.com", cohort: "Established", added: "Bytespider", search: "Lets OAI-SearchBot and PerplexityBot in" },
    { site: "getthematic.com", cohort: "Y Combinator", added: "7 training crawlers, including GPTBot, ClaudeBot and Google-Extended", search: "Lets OAI-SearchBot, Claude-SearchBot and PerplexityBot in" },
    { site: "sendbird.com", cohort: "Y Combinator", added: "5 training crawlers, including ClaudeBot and Meta-ExternalAgent", search: "Lets OAI-SearchBot, PerplexityBot and DuckAssistBot in" },
    { site: "zuddl.com", cohort: "Y Combinator", added: "7 training crawlers, including GPTBot and CCBot", search: "Names none" },
    { site: "figma.com", cohort: "Established", added: "ClaudeBot and Claude-User", search: "Already blocked OAI-SearchBot, Claude-SearchBot and PerplexityBot in June", flag: true },
  ];
  return (
    <TableCard
      title="The seven sites that added a block this quarter"
      note="Newly blocked crawlers between June 27 and September 15, 2026, and how the same file treats the five AI search crawlers we track."
      minWidth={640}
    >
      <thead>
        <tr>
          {["Site", "Cohort", "Newly blocked", "AI search crawlers in the same file"].map((h) => (
            <th key={h} style={thStyle}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.site}>
            <td style={{ ...tdStyle, color: TEXT, fontWeight: 700, fontFamily: "var(--mono)", fontSize: 13, whiteSpace: "nowrap" }}>{r.site}</td>
            <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>{r.cohort}</td>
            <td style={tdStyle}>{r.added}</td>
            <td style={{ ...tdStyle, color: r.flag ? AMBER : TEXT_DIM }}>{r.search}</td>
          </tr>
        ))}
      </tbody>
    </TableCard>
  );
}

/* ── Visual 4: CloudflareDefaultsTable ── the announced September 15, 2026 defaults */
function CloudflareDefaultsTable() {
  const rows = [
    { behavior: "Search", means: "Crawlers that index your content to answer questions about it later", onAdPages: "Allowed", named: "None named" },
    { behavior: "Agent", means: "Automated activity acting in real time on a person's behalf", onAdPages: "Blocked", named: "ChatGPT-User" },
    { behavior: "Training", means: "Crawlers that take your content to train or fine-tune a model", onAdPages: "Blocked", named: "None named" },
    { behavior: "Search and training combined", means: "One crawler used for both jobs", onAdPages: "Blocked wherever training is blocked", named: "Googlebot, Applebot, Bingbot" },
  ];
  return (
    <TableCard
      title="Cloudflare's announced defaults for September 15, 2026"
      note="For new customers, new sites, and existing free-plan customers who have not changed their settings. Per Cloudflare's July 1, 2026 press release, blog, and bot documentation, accessed September 15, 2026."
      minWidth={600}
    >
      <thead>
        <tr>
          {["Behavior", "What it covers", "Default on ad pages", "Examples named"].map((h) => (
            <th key={h} style={thStyle}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.behavior}>
            <td style={{ ...tdStyle, color: TEXT, fontWeight: 700, minWidth: 110 }}>{r.behavior}</td>
            <td style={tdStyle}>{r.means}</td>
            <td style={{ ...tdStyle, color: r.onAdPages === "Allowed" ? TEAL : AMBER, fontWeight: 700 }}>{r.onAdPages}</td>
            <td style={tdStyle}>{r.named}</td>
          </tr>
        ))}
      </tbody>
    </TableCard>
  );
}

const faqs = [
  {
    q: "Are B2B SaaS companies blocking more AI crawlers in 2026?",
    a: "Slightly more blocks, and far more rules that let crawlers in. Across 358 B2B SaaS sites scanned in both June and September 2026, rules blocking an AI crawler rose from 44 to 55, while rules letting one in rose from 349 to 552. No site newly blocked an AI search crawler, and only 2 of 362 readable sites, 0.6%, block one at all.",
  },
  {
    q: "Does Cloudflare block AI crawlers by default?",
    a: "Not on every site. Cloudflare announced defaults for September 15, 2026 that allow search crawlers but block AI training and agent bots on pages that show ads, for new customers, new sites, and existing free-plan customers who have not changed their settings. Every Cloudflare site can set Search, Agent and Training separately. Cloudflare described September 15 as a deadline to finalize the defaults, and we found no Cloudflare page confirming they went live.",
  },
  {
    q: "Can Cloudflare block Googlebot?",
    a: "Yes, if you block AI training. Cloudflare's documentation says crawlers that combine search and training are blocked by any setting that blocks AI training, including the older Block AI bots option, and it names Googlebot, Applebot and Bingbot as examples. A Training setting that blocks on all pages therefore blocks Googlebot on all pages.",
  },
  {
    q: "What percentage of B2B SaaS websites block GPTBot?",
    a: "1.9%. In our September 15, 2026 scan of 390 B2B SaaS websites, 7 of the 362 sites with a readable robots.txt block GPTBot, OpenAI's training crawler. Far more go the other way: 62 sites name GPTBot in robots.txt without blocking it, up from 44 in June.",
  },
  {
    q: "Can you block AI training crawlers but still allow AI search crawlers?",
    a: "Yes. robots.txt applies rules per crawler, so a file can disallow a training crawler such as GPTBot while allowing OAI-SearchBot and PerplexityBot. Seven sites in our panel block at least one training crawler while letting AI search crawlers in, including GitHub, Postman and Amplitude. On Cloudflare the same split is a setting, with one catch: blocking training also blocks crawlers that combine search and training, such as Googlebot.",
  },
  {
    q: "Does robots.txt stop AI crawlers?",
    a: "Only crawlers that choose to follow it. RFC 9309, the robots.txt standard, states that its rules are not a form of access authorization. To enforce a block, or to confirm a block is not happening, check the layer in front of your site, such as Cloudflare's AI bot settings or your firewall rules.",
  },
  {
    q: "Which AI crawler do B2B SaaS companies block most?",
    a: "Bytespider, ByteDance's crawler. In our September 15, 2026 scan it is blocked by 12 of 362 readable B2B SaaS sites, 3.3%, overtaking Common Crawl's CCBot at 8. GitHub, Postman and Amplitude all added Bytespider blocks between June and September 2026.",
  },
];

function Content() {
  return (
    <article>
      {/* Overview box */}
      <div style={{ background: TEAL_DIM, border: `1px solid ${TEAL_BORDER}`, borderRadius: 12, padding: "24px 28px", margin: "0 0 36px" }}>
        <P>
          <Strong>Mostly no.</Strong> The few that added blocks aimed almost all of them at AI training crawlers, never at AI search. We scanned the robots.txt of the same 390 B2B SaaS websites on June 27 and again on September 15, 2026, the date Cloudflare set for its new AI crawler defaults. In the eleven weeks between the two scans, B2B SaaS companies wrote <A href="/glossary/ai-crawlers">AI crawlers</A> into their robots.txt files by name, and most of those new rules let the crawlers in.
        </P>
        <ul style={{ paddingLeft: 20, margin: "0 0 4px" }}>
          <Li><Strong>More rules.</Strong> Sites naming AI crawlers rose from 55 to 76 of the 358 we could read both times</Li>
          <Li><Strong>Mostly yes.</Strong> 23 of the 24 companies writing AI-crawler rules for the first time let at least one crawler in</Li>
          <Li><Strong>No new search blocks.</Strong> Seven companies added blocks, and none of the new blocks hit an AI search crawler</Li>
          <Li><Strong>The edge decides.</Strong> 32 of the 62 sites that let GPTBot in are served through Cloudflare, whose settings can overrule robots.txt</Li>
        </ul>
      </div>

      <H2 id="what-changed">What changed since June: more rules, mostly letting crawlers in</H2>
      <P>
        B2B SaaS companies spent the summer writing AI crawlers into robots.txt by name, and most of the new rules <Strong>say yes</Strong>. This is the September 2026 edition of our <A href="/research/ai-bot-blocking-index">AI Bot Blocking Index</A>: the same panel of 390 companies and the same 17 crawlers as the June scan, so every change below is a change on the same site.
      </P>
      <EditionStats />
      <P>
        Rules that let an AI crawler in grew by 203 between the two scans. Rules that block one grew by 11. Here, a rule lets a crawler in when the file names it and does not block the whole site. Some of those rules still fence off individual pages: GitHub names GPTBot, OAI-SearchBot, ClaudeBot and PerplexityBot in one group with page-level allow and disallow lines.
      </P>
      <EditionCompare />
      <P>
        Naming a crawler did not unlock anything. Under <A href={RFC_9309}>RFC 9309</A>, the robots.txt standard, a crawler a file does not name follows the file&apos;s wildcard rules, and no site in the panel blocks everything with a wildcard. These rules record a decision the companies chose to write down.
      </P>
      <P>
        Twenty-four companies wrote AI-crawler rules for the first time, and 20 of them only let crawlers in. Hootsuite, Unbounce, Zscaler, Palo Alto Networks, Recurly and ChurnZero are among them. The change was even across both cohorts: 21.6% of established brands and 21.5% of Y Combinator companies with a readable robots.txt now have an explicit AI-crawler rule, up from 16.1% and 14.6% in June. One site, suger.io, wrote the panel&apos;s first rule for <A href="/blog/what-is-oai-adsbot">OAI-AdsBot</A>, OpenAI&apos;s ChatGPT Ads crawler, and it lets it in.
      </P>
      <PullQuote>
        B2B SaaS did not spend the quarter before Cloudflare&apos;s new defaults locking AI crawlers out. It spent it writing them in by name.
      </PullQuote>

      <H2 id="new-blocks">The seven companies that added blocks, and what they left open</H2>
      <P>
        Seven companies added a block this quarter, and six of them blocked <Strong>only AI training crawlers</Strong>. Five of the seven name AI search crawlers in the same file without blocking them.
      </P>
      <NewBlocksTable />
      <P>
        Bytespider, ByteDance&apos;s crawler, was the most common new target. GitHub, Postman and Amplitude each added a site-wide block for it and no other new block. It is now the most-blocked crawler in the panel, at 12 of 362 readable sites, overtaking Common Crawl&apos;s CCBot at 8.
      </P>
      <P>
        Three Y Combinator companies went wider. getthematic.com and Zuddl each blocked seven training crawlers, and Sendbird, which already blocked GPTBot in June, added five more. Figma is the one site that fits neither pattern. It added blocks for ClaudeBot and Claude-User, Anthropic&apos;s crawler that fetches a page when a Claude user asks for it, and it has blocked three AI search crawlers since at least June.
      </P>
      <P>
        No company newly blocked an AI search crawler. Only two sites block one at all: Figma, and ZoomInfo, which blocks DuckDuckGo&apos;s DuckAssistBot. The count fell from three to two because panoramaed.com removed all 16 of its AI-crawler rules, including an old block on Applebot.
      </P>

      <H2 id="cloudflare-defaults">What Cloudflare announced for September 15, 2026</H2>
      <P>
        Cloudflare announced new defaults that <Strong>allow search crawlers</Strong> but block AI training and agent bots on pages that show ads. According to <A href={CLOUDFLARE_PRESS}>Cloudflare&apos;s July 1 press release</A>, they apply to new customers, to new sites added by existing customers, and to existing free-plan customers who have not changed their settings by September 15.
      </P>
      <CloudflareDefaultsTable />
      <P>
        Three details matter more than the headline:
      </P>
      <ul style={{ paddingLeft: 20, margin: "0 0 18px" }}>
        <Li><Strong>Googlebot is included.</Strong> <A href={CLOUDFLARE_AI_BOTS_DOC}>Cloudflare&apos;s documentation</A> says crawlers that combine search and training are blocked by every setting that blocks AI training, including the older Block AI bots option. That matters because Google&apos;s <A href="/glossary/google-ai-overviews">AI Overviews</A> run on the ordinary Googlebot crawl.</Li>
        <Li><Strong>The old toggle retires.</Strong> The same documentation marks Block AI bots as deprecating on September 15, 2026, while the separate Search, Agent and Training settings each offer three options: block on all pages, block only on pages with ads, or allow.</Li>
        <Li><Strong>Announced, not confirmed.</Strong> Cloudflare said it would test and finalize the defaults before September 15. We found no Cloudflare page confirming they went live, so this post describes what was announced.</Li>
      </ul>
      <P>
        On the default settings, only pages that Cloudflare&apos;s automated detection finds showing ads are affected. The riskier case is a site that chose to block AI training on every page, because Cloudflare says that choice also blocks Googlebot on every page.
      </P>
      <PullQuote>
        On Cloudflare, a choice to block AI training on every page is also a choice to block Googlebot on every page.
      </PullQuote>

      <H2 id="same-line">The companies that blocked drew the line Cloudflare now draws</H2>
      <P>
        The B2B SaaS companies that blocked AI crawlers <Strong>separated training from search</Strong>, the same split Cloudflare&apos;s new settings are built on. Of the 16 sites in the panel that block at least one training crawler, 7 let AI search crawlers in and block none of them: Amplitude, getthematic.com, GitHub, Postman, Secoda, Sendbird and Volopay.
      </P>
      <P>
        Our categories are close to Cloudflare&apos;s but not identical. We class Applebot as a search crawler, while Cloudflare treats it as one crawler doing both jobs. Cloudflare&apos;s Agent group includes ChatGPT-User, which our index classes as user-initiated, and only one site blocks a crawler of that kind: Figma, which blocks ChatGPT-User and Claude-User.
      </P>
      <P>
        Far more sites went the other way from Cloudflare&apos;s training default. 62 now name GPTBot, OpenAI&apos;s training crawler, without blocking it, up from 44 in June. For the full case on which OpenAI crawler to keep, see <A href="/blog/gptbot-vs-oai-searchbot">GPTBot vs OAI-SearchBot</A>.
      </P>

      <H2 id="edge">Half the sites that let GPTBot in sit behind Cloudflare</H2>
      <P>
        A robots.txt rule is <Strong>a request</Strong>, and Cloudflare&apos;s settings are enforcement that runs before the file is ever read. Of the 62 sites that let GPTBot in by name, 32 are served through Cloudflare. Of the 70 sites that let any AI crawler in by name, 35 are.
      </P>
      <P>
        Our scan cannot see which Cloudflare plan those sites are on, what their dashboard settings say, or whether any of their pages show ads. So we cannot say how many of them block the crawlers their robots.txt invites. What the data does show is that for half of the companies writing yes to AI crawlers, the final answer depends on a setting outside that file. The standard is blunt about it: robots.txt rules &ldquo;are not a form of access authorization.&rdquo;
      </P>
      <P>
        That gap between the file and the edge is the two-layer problem laid out in our <A href="/blog/robots-txt-ai-bots-2026">guide to which AI crawlers to allow</A>, and it can quietly cost you the <A href="/glossary/ai-citation">AI citations</A> the file was meant to earn. The quickest outside signal is your server logs: if <A href="/glossary/ai-bot-traffic">AI bot traffic</A> from the crawlers you allow never shows up, something in front of your origin may be turning them away. Our <A href="/blog/how-to-track-ai-bot-activity">bot activity guide</A> shows how to check.
      </P>

      <H2 id="what-to-check">What to check this week if your site is on Cloudflare</H2>
      <P>
        <Strong>Four checks</Strong>, in order, cover the changes Cloudflare announced.
      </P>
      <ol style={{ paddingLeft: 22, margin: "0 0 18px" }}>
        <Li><Strong>AI bot policies.</Strong> In the Cloudflare dashboard, go to Security Settings, then Configure AI bot policies. If you want AI search engines to cite you, Search should be set to allow.</Li>
        <Li><Strong>Training and Googlebot.</Strong> If Training blocks on all pages, crawlers that combine search and training are blocked on all pages too, and Cloudflare names Googlebot, Applebot and Bingbot. Decide whether keeping AI training out is worth that.</Li>
        <Li><Strong>The legacy setting.</Strong> Cloudflare marks Block AI bots as deprecating on September 15, 2026. If your team ever switched it on, confirm the new Search, Agent and Training settings say what you intend.</Li>
        <Li><Strong>Blocked crawlers.</Strong> Under Security, then Analytics, the Events tab shows blocked AI bot traffic. <A href={CLOUDFLARE_BFM_DOC}>Bot Fight Mode</A> can challenge crawlers as well, and Cloudflare says custom rules cannot skip it, so if it is stopping a crawler you need, switch it off.</Li>
      </ol>
      <P>
        Then confirm the file itself says what you think. A crawler is blocked from your whole site only when its group, or the wildcard group it falls back to, contains a bare <Code>Disallow: /</Code>. An empty <Code>Disallow:</Code> line allows everything.
      </P>
      <InlineCTA href="/tools/ai-bot-checker" label="Run the free AI Bot Access Checker">
        The free AI Bot Access Checker reads your live robots.txt against 25 AI crawlers, using the same parser as this index, and flags whether your site is served through Cloudflare. No signup.
      </InlineCTA>

      <H2 id="limits">What this scan cannot tell you</H2>
      <P>
        The scan reads robots.txt and its response headers. It <Strong>does not test</Strong> whether a crawler actually gets through.
      </P>
      <ul style={{ paddingLeft: 20, margin: "0 0 18px" }}>
        <Li><Strong>Enforcement.</Strong> robots.txt shows what a company asks crawlers to do. A Cloudflare setting or firewall rule can override it, and the scan tests neither.</Li>
        <Li><Strong>Cloudflare plans and settings.</Strong> We detect Cloudflare from response headers. Plan, dashboard settings and ad detection are invisible to us, so we make no estimate of how many sites Cloudflare&apos;s defaults affect.</Li>
        <Li><Strong>Motives.</Strong> A robots.txt change shows what changed, never why.</Li>
        <Li><Strong>The wider web.</Strong> This is a fixed panel of 390 B2B SaaS companies, not a sample of all websites, so its rates should not be read as web-wide.</Li>
        <Li><Strong>Timing.</Strong> The September scan ran on the date Cloudflare set. It measures the quarter before the new defaults, not their effect.</Li>
      </ul>

      <H2 id="method">How we measured</H2>
      <P>
        We fetched the robots.txt of the same 390 B2B SaaS websites on June 27 and September 15, 2026, and checked each file against <Strong>the same 17 crawlers</Strong>. The panel is fixed: 153 established B2B SaaS brands and 237 active B2B SaaS companies from the Y Combinator directory, the same sites we checked for a valid llms.txt on October 1, 2026 in <A href="/blog/do-b2b-saas-companies-publish-llms-txt">our llms.txt study</A>.
      </P>
      <P>
        Each file is parsed per crawler with the RFC 9309 parser behind our AI Bot Access Checker. A crawler counts as blocked when its group, or the wildcard group it falls back to, disallows the whole site. It counts as let in when the file names it without blocking the whole site, and as unnamed otherwise. Change figures use only the 358 sites whose robots.txt was readable in both scans. Four sites became unreachable and four came back, and none of those count as changes. Rates for a single edition use that scan&apos;s 362 readable sites.
      </P>
      <P>
        Every site, crawler and figure is downloadable under CC BY 4.0 in the <A href="/research/ai-bot-blocking-index/2026-q3">September 2026 edition</A>, and the <A href="/research/ai-bot-blocking-index/2026-q2">June 2026 edition</A> stays at its own URL, so both sets of numbers remain citable.
      </P>

      {/* FAQPage JSON-LD */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map((faq) => ({
          "@type": "Question",
          "name": faq.q,
          "acceptedAnswer": { "@type": "Answer", "text": faq.a },
        })),
      }) }} />

      {/* FAQ section */}
      <H2 id="faq">Frequently Asked Questions</H2>
      <FAQItems faqs={faqs} />

      {/* Related Reading */}
      <H2 id="related">Related Reading</H2>
      <ul style={{ paddingLeft: 20, margin: "0 0 18px" }}>
        <Li><A href="/blog/robots-txt-ai-bots-2026">AI Crawlers in 2026: Which Bots to Allow and Which to Block</A></Li>
        <Li><A href="/blog/gptbot-vs-oai-searchbot">GPTBot vs OAI-SearchBot: Why Blocking the Wrong One Kills Your ChatGPT Visibility</A></Li>
        <Li><A href="/blog/how-to-track-ai-bot-activity">How to Track AI Bot Activity on Your Website</A></Li>
        <Li><A href="/blog/what-is-oai-adsbot">What Is OAI-AdsBot? (OpenAI&apos;s ChatGPT Ads Crawler)</A></Li>
        <Li><A href="/blog/track-ai-referral-traffic">Is AI Search Driving Traffic to Your Website?</A></Li>
      </ul>
    </article>
  );
}

const post = {
  slug: "are-b2b-saas-companies-blocking-ai-crawlers",
  title: "Are B2B SaaS Companies Blocking AI Crawlers? September 2026 Data",
  seoTitle: "Do B2B SaaS Sites Block AI Crawlers? September 2026 Data",
  excerpt: "Same 390 B2B SaaS sites, June vs September 2026: 24 wrote AI-crawler rules for the first time, and 23 let crawlers in before Cloudflare's new defaults.",
  metaDescription: "We re-scanned 390 B2B SaaS sites on September 15, 2026. Sites with AI-crawler rules rose 38%, mostly to let crawlers in, and none newly blocked AI search.",
  date: "2026-09-15",
  lastUpdated: "2026-10-01",
  readTime: "10 min read",
  category: "AI Analytics",
  tags: ["AI crawlers", "robots.txt", "Cloudflare AI crawler defaults", "AI Bot Blocking Index", "B2B SaaS", "GPTBot", "AI search crawlers"],
  fiveA: "analytics",
  Content,
};

export default post;
